import React, { useEffect, useState } from "react";
import "./Wishlist.scss";
import photo from "../../assets/homePage/photo.jpg";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Wishlist = () => {
  const [product, setProduct] = useState([]);
  const navigate = useNavigate();
  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");

  const getWishProductList = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `wishlist/getWishlist`,
      method: "post",
      data: {
        userId: userId, // this is userIds
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          setProduct(response?.data?.data);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const removeFromCart = (item) => {
    console.log(item);
    // return;
    const config = {
      url: process.env.REACT_APP_BASE_URL + `wishlist/deleteWishlist`,
      method: "post",
      data: {
        userId: userId, // this is userIds
        productId: item?._id,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        if (response?.data?.status == true) {
          console.log(response?.data);
          getWishProductList();
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getWishProductList();
  }, []);

  return (
    <>
      <div className="wishlist-main">
        <div className="wishlist-outer">
          <div className="wishlist-inner">
            <div className="wishlist-head">
              <div className="head-outer">
                <h1 className="text-center">WISHLIST</h1>
              </div>
            </div>
            <div className="wishlist-body">
              <div className="body-outer row">
                <div className="body row justify-content-center   gap-2 mt-2">
                  {product?.productId?.map((item, index) => (
                    <div key={index} className="body-inner d-flex mt-4">
                      <div className="part11 col-6">
                        <img src={item?.image[0]} alt={item?.productName} />
                      </div>
                      <div className="part22 col-6 mt-3">
                        <div className="part">
                          <p>{item?.productName}</p>
                          <div className="part ">
                            <p className=""> {Math.ceil(item?.price)} /-</p>
                          </div>
                        </div>
                        <div className="part">
                          <p>{item.stockStatus}</p>
                        </div>
                        <div className="part  ">
                          <div className="part-outer">
                            <div className="part-inner">
                              <button
                                onClick={() => {
                                  navigate(`/product/${item._id}`);
                                  window.scrollTo(0, 0);
                                }}
                              >
                                SELECT OPTIONS
                              </button>
                            </div>
                          </div>
                          <div className="part33 mt-3">
                            <button onClick={() => removeFromCart(item)}>
                              <i class="bi bi-x-circle fs-5"></i>
                              {/* REMOVE */}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {/* <hr /> */}
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Wishlist;
